import request from '@aned/request';

export const getList = (params) => {
  return request('/api/routeAlterFlow/queryRouteAlterFlowList', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'temporary'
  });
}

// 添加单号
export const addWayBillNo = (params) => {
  return request('/api/routeTemporary/queryHbaseByWaybillNo', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'temporary'

  });
}

// 新增
export const insert = (params) => {
  return request('/api/routeAlterFlow/submitRouteAlterFlow', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'temporary'

  });
}

// 审核
export const audit = (params) => {
  return request('/api/routeAlterFlow/auditRouteAlterFlow', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'temporary'
  });
}